import React, { useEffect, useState, useRef } from 'react';
import './Principal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh, faStar, faUsers, faFileShield, faShieldAlt, faCog, faChevronLeft, faChevronRight, faListAlt, faThLarge, faTools, faExchangeAlt} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalOpcoesIcone, ConfirmationModal, LogoutConfirmationModal, UserProfileModal, ModalPermissoesGrupo } from '../Modais/Modal';
import Registro from './Registro';
import Toast from '../Modais/Toast';
import Favoritos from '../Favoritos/Favoritos';
import Grupo from './Grupo';
import Swal from 'sweetalert2';
import Usuarios from '../Usuarios/Usuarios';
import Config from '../Usuarios/Config';
import { useNavigate } from 'react-router-dom';


import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'; 
import Auditoria from '../Auditoria/Auditoria';
import Ferramentas from '../Ferramentas/Ferramentas';
import Empresas from '../Empresas/Empresas';

library.add(fas, fab, far);
library.add(faTh, faStar, faUsers, faFileShield, faShieldAlt, faCog, faChevronLeft, faChevronRight);

function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
}

function Principal () {

    const [grupos, setGrupos] = useState([]); // Estado para armazenar os grupos
    const [showCopySuccess, setShowCopySuccess] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [titulo, setTitulo] = useState('');
    const [imagem, setImagem] = useState('');
    const [cor, setCor] = useState('primary');
    const [showGroupDetails, setShowGroupDetails] = useState(false);
    const [selectedGrupoDetalhes, setSelectedGrupoDetalhes] = useState(null);
    const [showAddRecordFormOnly, setShowAddRecordFormOnly] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const [showPasswordPopup, setShowPasswordPopup] = useState(false);
    const [passwordToShow, setPasswordToShow] = useState('');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null); // Pode ser um grupo ou um registro
    const [toast, setToast] = useState({ message: '', type: '', visible: false });
    const [showFavoritos, setShowFavoritos] = useState(false);
    const [selectedGrupoOptions, setSelectedGrupoOptions] = useState(null);
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
    const [autorizado, setAutorizado] = useState(null);
    const [selectedButton, setSelectedButton] = useState('meusGrupos');
    const [filtroPesquisa, setFiltroPesquisa] = useState("");
    const [recarregarGrupos, setRecarregarGrupos] = useState(false);
    const [showConfigModal, setShowConfigModal] = useState(false);
    const [permissao, setPermissao] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [empresaNome, setEmpresaNome] = useState('');
    // O CRM agora vive em shell/rota própria (/crm — ver src/crm/CrmShell.jsx,
    // §4 do redesign). Aqui o Cofre só precisa saber SE o tenant/usuário tem
    // CRM acessível, pra mostrar (ou não) o ponto de entrada do app switcher.
    // Fail-closed: começa escondido até a resposta confirmar.
    const [crmAcessivel, setCrmAcessivel] = useState(false);

    const fetchModulosHabilitados = async () => {
        try {
            const token_autorizado = getCookie("info");
            const base = process.env.REACT_APP_GESTAO_API_URL || '';
            const response = await fetch(`${base}/api/modulos/meus`, {
                method: 'GET',
                headers: { 'Authority': token_autorizado },
            });
            const result = await response.json();
            setCrmAcessivel(result.status === "ok");
        } catch (error) {
            // Sem CRM habilitado pro tenant (token sem 'crm' no aud) ou erro de
            // rede — em ambos os casos, esconde (fail-closed).
            setCrmAcessivel(false);
        }
    };
    const logoClickCountRef = React.useRef(0);
    const logoClickTimer = React.useRef(null);
    const navigate = useNavigate();
    
    const fetchDetalheUsuario = async () => {
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/buscar`, {
                method: 'GET',
                headers: {
                    'Authority': token_autorizado,
                },
            });
    
            const result = await response.json();
            
            if (result.status === "ok") {
                setPermissao(result.cargo === "Admin" || result.is_super_admin);
                setIsSuperAdmin(result.is_super_admin === true);
                setEmpresaNome(result.empresa_nome || '');
            } else {
                showToast(result.mensagem || 'Erro ao carregar dados do usuário', 'error');
            }
        } catch (error) {
            console.error('Erro ao buscar dados do usuário:', error);
            showToast('Erro ao carregar dados do usuário', 'error');
            navigate("/");
    
        }
       
    }

    // Função para redirecionar ao Painel de Tarefas com SSO

    useEffect(() => {
        
        const token_autorizado = getCookie("info");

        if (!token_autorizado) {
            navigate("/");
            return;
        } else {
            setAutorizado(true); // Define como autorizado
            fetchDetalheUsuario();
            fetchModulosHabilitados();
        }
    }, []);

    const backgroundStyle = {
        backgroundColor: '#0B051A',
        backgroundImage: 'none',
        color: '#666',
    };

    const handleLogout = () => {
        setShowLogoutConfirmation(true); // Exibe o modal de confirmação
    };
    
    const confirmLogout = () => {
        document.cookie = "info=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"; // Limpa o cookie
        window.location.href = "/"; // Redireciona para a página de login
    };

    const handleAddRecord = () => {
        setShowAddRecordFormOnly(true);
    };

    const handleCopyPassword = (senha) => {
        setShowPasswordPopup(false); // Fecha o pop-up de senha antes de copiar
        navigator.clipboard.writeText(senha).then(() => {
            setShowCopySuccess(true); // Mostra o pop-up de confirmação
            setTimeout(() => setShowCopySuccess(false), 3000); // Oculta após 2 segundos
        });
    };
    

    const handleButtonClick = (buttonName) => {
        setFiltroPesquisa("");

        if (buttonName === selectedButton && buttonName === 'meusGrupos') {
            setRecarregarGrupos(prev => !prev);
        } else {
            // Troca de "página"
            setSelectedButton(buttonName);
        }
       
        if (buttonName === 'meusGrupos') {
            setTimeout(() => {
                setShowFavoritos(false);
                setShowGroupDetails(false);
                setSelectedGrupoDetalhes(null);
            }, 50); // 50ms já costuma ser o suficiente
        }
        //setSelectedButton(buttonName);
        setShowFavoritos(buttonName === 'favoritos'); 
    };
    
    const onGrupoSelecionado = (grupo) => {
        if (!grupo.registros) {
            grupo.registros = [];
        }
        setSelectedButton('registros');
        setSelectedGrupoDetalhes(grupo);
        setShowGroupDetails(true);
        
        buscarRegistrosPorGrupo(grupo.id);
    };

    const handleBackToCards = () => {
        
        if (showFavoritos) {
           
            setShowFavoritos(false); // Sai da aba de favoritos 
            setShowGroupDetails(false);
            setSelectedGrupoDetalhes(false);
            setSelectedButton('meusGrupos'); 
        } else {
           
            //setFiltroPesquisa("");       
            setShowGroupDetails(false);
            setSelectedGrupoDetalhes(false);
            setSelectedButton('meusGrupos');
        }
    };

    const handleLogoClick = () => {
        logoClickCountRef.current += 1;
        clearTimeout(logoClickTimer.current);
        if (logoClickCountRef.current >= 3) {
            logoClickCountRef.current = 0;
            if (isSuperAdmin) handleButtonClick('empresas');
            return;
        }
        logoClickTimer.current = setTimeout(() => {
            logoClickCountRef.current = 0;
            handleBackToCards();
        }, 500);
    };

    const navigateToGroup = (groupId) => {
        // Encontre o grupo pelo ID
        const grupo = grupos.find(g => g.id === groupId);
        if (grupo) {
            setSelectedGrupoDetalhes(grupo);
            setShowGroupDetails(true);
            setSelectedButton('registros');
            buscarRegistrosPorGrupo(grupo.id); // Carrega os registros do grupo
        } else {
            showToast('Grupo não encontrado', 'error');
        }
    };

    const adicionarGrupo = () => {
        setTitulo(''); // Limpa o título
        setImagem(''); // Limpa o ícone
        setCor('primary'); // Define uma cor padrão
        setSelectedGrupoDetalhes(null); // Limpa o grupo selecionado
        setIsEditing(false); // Define o modal para o modo de criação
        setShowModal(true); // Abre o modal
    };
   
    const handleShowPassword = (senha) => {
        setPasswordToShow(senha); // Define a senha a ser exibida
        setShowPasswordPopup(true); // Abre o pop-up
    
        // Fecha o pop-up automaticamente após 30 segundos
        setTimeout(() => {
            setShowPasswordPopup(false);
        }, 30000);
    };

    const showToast = (message, type, className='') => {
        setToast({ message, type, visible: true, className });
        setTimeout(() => {
            setToast({ message: '', type: '', visible: false, });
        }, 3000); // Fecha o Toast após 3 segundos
    };
    
    const handleDownload = (arquivo) => {
        if (!arquivo) {
            showToast('Nenhum arquivo disponível para download.', 'error');
            return;
        }
    
        const url = URL.createObjectURL(arquivo);
        const link = document.createElement('a');
        link.href = url;
        link.download = arquivo.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    
    // Fecha o menu ao clicar fora dele
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.options-menu') && !event.target.closest('.options-button')) {
                setSelectedGrupoOptions(null);
            }
        };
    
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    if (autorizado === null) {
        return null; // Não renderiza nada até validar
    }

    const buscarRegistrosPorGrupo = async (grupoId) => {
        try {
            const token_autorizado = getCookie("info");
    
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/grupos/buscar_registros_por_grupo`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ grupo_id: grupoId }),
            });
    
            const result = await response.json();
    
            if (result.status === "ok") {
                setSelectedGrupoDetalhes(prev => ({
                    ...prev,
                    registros: result.registros, // Atualiza os registros do grupo selecionado
                    opcaoEdicao: result.opcaoEdicao
                }));        
            } else {
                showToast(result.mensagem, "error");
            }
        } catch (error) {
            console.error(error);
            showToast("Erro ao buscar registros. Tente novamente mais tarde.", "error");
        }
    };
    
    return (
        <div style={backgroundStyle}>
            <div className="container">
                <aside className={`left-sidebar `}>
                    <div className="sidebar-header">
                        <img src="lockus-icon.svg" alt="Logo" className="logo" style={{cursor: 'pointer'}} onClick={handleLogoClick}/>
                        {empresaNome && <div style={{ color: '#aaa', fontSize: '11px', textAlign: 'center', padding: '4px 4px 0', wordBreak: 'break-word' }}>{empresaNome}</div>}
                    </div>
                    <nav className="menu">
                        <ul>
                            <li id="listar_meus_grupos" className="icon-button" title="Meus Grupos" onClick={() => handleButtonClick('meusGrupos')}>
                                <FontAwesomeIcon icon={faThLarge} />
                            </li>
                            <li id="listar_meus_favoritos" className="icon-button" title="Meus Favoritos" onClick={() => handleButtonClick('favoritos')}>
                                <FontAwesomeIcon icon={faStar} />
                            </li> 
                            {permissao && (             
                                <li id="listar_gerenciamento_usuarios" className="icon-button" title="Gerenciamento de usuarios" onClick={() => handleButtonClick('usuarios')}>
                                    <FontAwesomeIcon icon={faUsers} />
                                </li>   
                            ) }                 
                            <li id="listar_auditoria" className="icon-button" title="Auditoria" onClick={() => handleButtonClick('auditoria')}>
                                <FontAwesomeIcon icon={faListAlt} />
                            </li>
                            <li id="central_de_ferramentas" className="icon-button" title="Ferramentas" onClick={() => handleButtonClick('ferramentas')}>
                                <FontAwesomeIcon icon={faTools} />
                            </li>
                        </ul>
                    </nav>
                    {crmAcessivel && (
                        <div className="bottom-icon icon-button" title="Abrir CRM" style={{ marginBottom: '70px' }} onClick={() => navigate('/crm')}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                        </div>
                    )}
                    <div className="bottom-icon icon-button" onClick={() => setShowConfigModal(true)}>
                        <FontAwesomeIcon icon={faCog} />
                    </div>
                </aside>
                            
                <main className="main-content">
                    <header className="main-header">
                        {/* <h1>{selectedGrupoDetalhes
                        ? 'Registros'
                        : { */}
                        <h1> {
                        {
                            meusGrupos: 'Grupos',
                            registros: 'Registros',
                            favoritos: 'Favoritos',
                            usuarios: 'Usuários',
                            auditoria: 'Auditoria',
                            ferramentas: 'Ferramentas',
                            empresas: 'Empresas',
                            config: 'config'
                        }[selectedButton] || 'Grupos'}
                        </h1>
                        {selectedButton === 'meusGrupos' && !showGroupDetails && (
                            <div className="search-container">
                                <Grupo
                                    tipo={"search"}
                                    filtroPesquisa={filtroPesquisa}
                                    setFiltroPesquisa={setFiltroPesquisa}
                                    selectedButton={selectedButton}
                                    grupos={grupos}
                                    setGrupos={setGrupos}
                                    onGrupoClick={onGrupoSelecionado}
                                    recarregar={recarregarGrupos}
                                    getCookie={getCookie}
                                    showToast={showToast}
                                />
                            </div>
                        )}
                        <div className="user-menu-container">
                            <button className="user-menu-button" title='Sair' onClick={handleLogout}>
                                <FontAwesomeIcon icon={faSignOutAlt} /> {/* Ícone de menu */}
                            </button>
                        </div>
                    </header>

                    {selectedButton === 'usuarios' ? (
                        <Usuarios
                            grupos={grupos}
                            setGrupos={setGrupos}
                            handleBackToCards={handleBackToCards} 
                            showToast={showToast}/>

                    
                    ) : selectedButton === 'auditoria' ? (
                        <Auditoria
                            grupos={grupos}
                            showToast={showToast}
                        />
                    ):

                    selectedButton === 'favoritos' ? (
                        <Favoritos
                            grupos={grupos}
                            handleBackToCards={handleBackToCards}
                            handleShowPassword={handleShowPassword}
                            handleCopyPassword={handleCopyPassword}
                            showCopySuccess={showCopySuccess}
                            setShowCopySuccess={setShowCopySuccess}
                            getCookie={getCookie}
                            handleDownload={handleDownload}
                            showToast={showToast}
                            grupoId={selectedGrupoDetalhes ? selectedGrupoDetalhes.id : null}
                            navigateToGroup={navigateToGroup}
                            selectedButton={selectedButton}
                        />

                    ): selectedButton === 'meusGrupos' && !showGroupDetails ?(
                        <div className="cards-container">
                            <Grupo
                                tipo={"central"}
                                filtroPesquisa={filtroPesquisa}
                                setFiltroPesquisa={setFiltroPesquisa}
                                selectedButton={selectedButton}
                                showGroupDetails={showGroupDetails}
                                grupos={grupos}
                                setGrupos={setGrupos}
                                onGrupoClick={onGrupoSelecionado}
                                recarregar={recarregarGrupos}
                                getCookie={getCookie}
                                showToast={showToast}
                            />
                        </div>
                    ) : selectedButton === 'ferramentas' ? (
                        <Ferramentas
                            showToast={showToast}
                        />
                    ) : selectedButton === 'empresas' ? (
                        <Empresas
                            showToast={showToast}
                        />
                    ) : (
                        <Registro
                            selectedGrupoDetalhes={selectedGrupoDetalhes}
                            setSelectedGrupoDetalhes={setSelectedGrupoDetalhes}
                            showAddRecordFormOnly={showAddRecordFormOnly}
                            setShowAddRecordFormOnly={setShowAddRecordFormOnly}
                            isEditing={isEditing}
                            setIsEditing={setIsEditing}
                            
                            handleBackToCards={handleBackToCards}
                            handleAddRecord={handleAddRecord}
                            handleCopyPassword={handleCopyPassword}
                            showCopySuccess={showCopySuccess}
                            setShowCopySuccess={setShowCopySuccess}
                            setShowPasswordPopup={setShowPasswordPopup}
                            
                            showToast={showToast}
                            grupos={grupos}
                            setGrupos={setGrupos}
                            getCookie={getCookie}
                            
                        />
                    )}
                </main>

                {showPasswordPopup && (
                <>
                    <div className="password-popup-overlay"></div> {/* Adiciona a cortina preta */}
                    <div className='password-popup'>
                        <div className='password-popup-content'>
                            <p>{passwordToShow}</p>
                            <div className='password-popup-buttons'>
                                <button
                                    className='btn-copy'
                                    onClick={() => {
                                        handleCopyPassword(passwordToShow); // Chama a função para copiar a senha
                                    }}
                                >
                                    Copiar
                                </button>
                                <button
                                    className='btn-close'
                                    onClick={() => setShowPasswordPopup(false)}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
                {toast.visible && (
                    <Toast
                        message={toast.message}
                        type={toast.type}
                        onClose={() => setToast({ message: '', type: '', visible: false })}
                    />
                )}
            </div>

            <ConfirmationModal
                show={showConfirmationModal}
                fecharModal={() => setShowConfirmationModal(false)}
                //handleConfirm={handleConfirmDelete}
                message="Tem certeza que deseja excluir este item?"
                additionalMessage={itemToDelete?.type === 'group' ? "Todos os registros deste grupo também serão apagados." : null}
            />

            <LogoutConfirmationModal
                show={showLogoutConfirmation}
                fecharModal={() => setShowLogoutConfirmation(false)}
                handleConfirm={confirmLogout}
            />


            <Config 
                show={showConfigModal}
                onClose={() => setShowConfigModal(false)}
                showToast={showToast}
            />

        </div>
    );
};

export default Principal;